import styles from './discussions.module.css'

import { LuSquarePen } from '@react-icons/all-files/lu/LuSquarePen'
import * as React from 'react'

import type { DiscussionVisibility } from 'types/discussion'

import { Flex, Text } from 'components/ds'

const COPY_BY_VISIBILITY: Record<
  DiscussionVisibility,
  { title: string; description: string }
> = {
  internal: {
    title: 'Add your first internal note',
    description: 'Notes left here are only visible to your team.',
  },
  client: {
    title: 'Add your first client note',
    description:
      'Notes left here are visible to clients on public share pages.',
  },
}

type Props = {
  visibility: DiscussionVisibility
}

const DiscussionsEmptyState = ({ visibility }: Props): React.ReactElement => {
  const { title, description } = COPY_BY_VISIBILITY[visibility]
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      gap="3"
      p="4"
      className={styles.emptyState}
      data-testid="notes-empty-state"
    >
      <Flex align="center" justify="center" className={styles.emptyStateIcon}>
        <LuSquarePen size={16} />
      </Flex>
      <Flex
        direction="column"
        align="center"
        gap="2"
        className={styles.emptyStateText}
      >
        <Text size="2" weight="bold">
          {title}
        </Text>
        <Text size="1" color="gray" align="center">
          {description}
        </Text>
      </Flex>
    </Flex>
  )
}

export default DiscussionsEmptyState
